import type { Time } from "@suse-o11y/date-time/time";
import type { Signal } from "@suse-o11y/signal";
import { createContext } from "react";

import type { TimeRange } from "../../../../../app/state/view/timeline/TimeRange";

export interface MonitorStatusDrawerContextValue {
	timestamp: Signal<Time>;
	timeRange: Signal<TimeRange>;
}

export const MonitorStatusDrawerContext = createContext<null | MonitorStatusDrawerContextValue>(null);
